import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const API_URL = "/api/clientCompliance";

export const clientComplianceService = {
  // Get all compliance docs for a client with status breakdown
  getByClient(clientId) {
    return api.getCall(`${API_URL}/client/${clientId}`);
  },

  // Upload a document to a client's compliance profile
  upload(clientId, formData) {
    return api.postFormDataCall(`${API_URL}/client/${clientId}/upload`, formData);
  },

  // Update a compliance document
  update(docId, data) {
    return api.putCall(`${API_URL}/${docId}`, data);
  },

  // Delete a compliance document
  destroy(docId) {
    return api.deleteCall(`${API_URL}/${docId}`);
  },

  // Toggle waive on a specific document
  waive(docId, reason) {
    return api.putCall(`${API_URL}/${docId}/waive`, { reason });
  },

  // Waive a compliance type for a client (no file needed)
  waiveType(clientId, complianceType, reason) {
    return api.postCall(`${API_URL}/client/${clientId}/waive-type`, {
      compliance_type: complianceType,
      reason,
    });
  },

  // Remove waiver from a compliance type
  unwaiveType(clientId, complianceType) {
    return api.postCall(`${API_URL}/client/${clientId}/unwaive-type`, {
      compliance_type: complianceType,
    });
  },

  // Mark a compliance form as satisfied in-person (with optional file upload)
  satisfyForm(clientId, data) {
    if (data instanceof FormData) {
      return api.postFormDataCall(`${API_URL}/client/${clientId}/satisfy-form`, data);
    }
    return api.postCall(`${API_URL}/client/${clientId}/satisfy-form`, data);
  },

  // View document inline
  viewDocument(docId) {
    return api.getBlobCall(`${API_URL}/${docId}/view`);
  },

  // Download document
  downloadDocument(docId) {
    return api.getBlobCall(`${API_URL}/${docId}/download`);
  },
};
